/**
 * ---------------------------------------------------------------------
 * 🔒 AUTOGENERATED BY VENDORISM
 * Removing this comment will prevent it from being managed by it.
 * ---------------------------------------------------------------------
 */

/* eslint-disable */
import SynSelect from './select.component.js';

export * from './select.component.js';
export default SynSelect;

SynSelect.define('syn-select');

declare global {
  interface HTMLElementTagNameMap {
    'syn-select': SynSelect;
  }
}
